module.exports = __webpack_public_path__ + "static/media/vista-admin-feature.c59e3676.png";